class TimeZone {

  // 获取支持的时区列表
  web(): string[] {
    return [
      'America/Atka',
      'Pacific/Gambier',
      'America/Vancouver',
      'Canada/Mountain',
      'America/Atikokan',
      'America/New_York',
      'America/Santiago',
      'America/Bahia',
      'America/Noronha',
      'Atlantic/Azores',
      'Europe/London',
      'Africa/Brazzaville',
      'Africa/Maputo',
      'Africa/Asmera',
      'Asia/Dubai',
      'Asia/Karachi',
      'Asia/Dhaka',
      'Asia/Bangkok',
      'Asia/Shanghai',
      'Asia/Tokyo',
      'Australia/Sydney',
      'Asia/Magadan',
      'Asia/Anadyr',
      'Pacific/Apia',
      'Pacific/Kiritimati'
    ];
  }

}

export const timezone = new TimeZone();
